import React from 'react';
import styled from 'styled-components';
import ProductBox from '@components/storefront/ProductBox';
import { ProductData } from '@data/storefront';
import Colors from '../Colors';

interface Props {
  productData: ProductData;
  title?: string;
  disableClickEvents?: boolean;
  hideDescription?: boolean;
  noUppercaseTitle?: boolean;
}

const ProductCard: React.FC<Props> = ({ productData, disableClickEvents, hideDescription, noUppercaseTitle }) => {
  return (
    <Container>
      <ProductBox data={productData} disableClickEvents={disableClickEvents} hideDescription={hideDescription} noUppercaseTitle={noUppercaseTitle} />
    </Container>
  );
};

export default ProductCard;

const Container = styled.div`
  width: 159px;

  .product-image-wrap {
    width: 159px;
    height: 188px;
    border-radius: 12px;
    background: ${Colors.sky};
  }

  a {
    font-size: 14px;
  }

  p {
    font-size: 12px;
  }
`;
